import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Charging from './Charging';
import './Reporting.css';
import Trip from './Trip';
import Status from './Status';
import Historical from './Historical';
import HistoricalAnalytics from './HistoricalAnalytics';
import HistoricDetails from '../records/HistoricDetails';
import CanPacketHealth from './CanPacketHealth';
import KmSummary from '../records/KmSummary';
import KmDailyKm from '../records/KmDailyKm';
import KmBadPings from '../records/KmBadPings';



const ReportingContainer = () => {
	const items = [
		{
			name: 'Charge',
			url: '/reports/charge',
			isShow: false
		},
		{
			name: 'Trip',
			url: '/reports/trip',
			isShow: false
		},
        {
			name: 'Status',
			url: '/reports/status',
			isShow: false
		},
		{
			name: 'Source Data',
			url: '/reports/historic-data',
			isShow: process.env.REACT_APP_ENV !== 'LIVE'
		},
		{
			name: 'Historical',
			url: '/reports/historical',
			isShow: false
		},
		{
			name: 'Historic Details',
			url: '/reports/historic-details',
			isShow: true
		},
		{
			name: 'CAN Health',
			url: '/reports/can-health',
			isShow: true
		},
		{
			name: 'KM Summary',
			url: '/reports/km-summary',
			isShow: true
		},
		{
			name: 'Daily KM',
			url: '/reports/km-daily',
			isShow: true
		},
		{
			name: 'Bad Pings',
			url: '/reports/km-bad-pings',
			isShow: true
		},

	];
	const location = useLocation();
	const currentRoute = location.pathname;

	return (
		<>
			<div className='reporting__container'>
				<div className='reporting__tab__container'>
					{items.filter(x => x.isShow).map((item) => (
						<>
							<Link
								to={item.url}
								className={`reporting-title reporting__vertical__line reporting__tabs ${
									currentRoute === item.url ? ' active__tab' : ''
								}`}
								data-testid={`tab-link-${item.name}`}
							>
								{item.name}
							</Link>
						</>
					))}
				</div>

				<div className='reporting__body_wrapper'>
					{(() => {
						switch (currentRoute) {
							case '/reports/charge':
								return <Charging/>;
							case '/reports/trip':
								return <Trip/>;
							case '/reports/status':
								return <Status/>;
							case '/reports/historic-data':
								return <Historical />;
							case '/reports/historical':
								return <HistoricalAnalytics />;
							case '/reports/historic-details':
								return <HistoricDetails />;
							case '/reports/can-health':
								return <CanPacketHealth />;
							case '/reports/km-summary':
								return <KmSummary />;
							case '/reports/km-daily':
								return <KmDailyKm />;
							case '/reports/km-bad-pings':
								return <KmBadPings />;
							default:
								return null;
						}
					})()}
				</div>
			</div>
		</>
	);
};

export default ReportingContainer;
